export const emptyWell = {
    key: undefined,
    parent: null,
    rowId: undefined,
    fieldName: null,
    latitude: null,
    longitude: null,
    name: null,
    referenceSystem: null,
    wellCategory: null,
    wellType: null,
    waterDepth: null,
    assetId: null,
    frontParentUuid: undefined,
    waterDepthValue: null,
    waterDepthAsAttributeUnit: null
}

export const emptyIntervention = {
    key: null,
    parent: null,
    rowId: null,
    tatic: null,
    start: null,
    end: null,
    name: null,
    responsible: null,
    isRealtime: null
}

export const emptySection = {
    key: null,
    rowId: null,
    parent: null,
    name: null,
    oD: null,
    startMD: null,
    finalMD: null,
    start: null,
    end: null,
    prevCasingOD: null,
    prevCasingFinalMD: null,
    riser: null,
    type: null
}

export const emptyRigTable = {
    key: null,
    rowId: null,
    parent: null,
    type: null,
    status: null,
    start: null,
    end: null
}

export const emptyRun = {
    key: null,
    rowId: null,
    parent: null,
    number: null,
    startMD: null,
    finalMD: null,
    start: null,
    end: null,
    type: null,
    tubularsIntervalPerTime: null,
    extendLastTubular: null
}

export const emptyCementPlug = {
    rowId: null,
    parent: null,
    startMD: null,
    finalMD: null
}

export const emptyTubularType = {
    key: null,
    rowId: null,
    parent: null,
    tubularType: null,
    permanentTubularInstallation: null,
    oD: null,
    startMD: null,
    finalMD: null,
    start: null,
    end: null,
    restrictedConnectionType: null,
    connectionType: null,
    thirdPartyResponsible: null,
    materialType: null
}

export const emptyPipeMovements = {
    key: null,
    rowId: null,
    parent: null,
    tubularType_id: null,
    restrictedPipeMovementType: null,
    restrictedPipeMovementSpeed: null,
    restrictedPipeMovementSpeedAcronym: null,
    startMD: null,
    finalMD: null,
    start: null,
    end: null
}

export const emptyConnection = {
    key: null,
    rowId: null,
    parent: null,
    tubularType_id: null,
    restrictionType: null,
    restrictedTimeConnection: null,
    restrictedTimeConnectionAcronym: null,
    startMD: null,
    finalMD: null,
    start: null,
    end: null
}

export const emptyRop = {
    key: null,
    rowId: null,
    parent: null,
    tubularType_id: null,
    restrictedRopType: null,
    restrictedRopSpeed: null,
    restrictedRopSpeedAcronym: null,
    startMD: null,
    finalMD: null,
    start: null,
    end: null
}
